import { ArnClientError } from '../ArnClientError';

export class AlreadyConnectedError extends ArnClientError {
  constructor(reason?: string) {
    super('Expected to be disconnected' + (reason ? ' ' + reason : ''));
  }
}
